const getInitialState = () => ({
    openRequests: [],
    failedRequests: [],
    updatedAt: 0,
    careProviders: {
        entries: {},
        maxCount: 0,
    },
    lastInteractiveId: null,
});

export default {
    getInitialState
};
